import React from "react";
import "./styles.scss";
import { TablePropTypes } from "../../propTypes";
import Row from "../Row";

const Body = ({ data, rowComponent: Component = Row, ...props }) => {
  return (
    <tbody>
      {data.map((row, rowIndex) => {
        return (
          <Component
            row={row}
            rowIndex={rowIndex}
            key={row[props.rowId]}
            {...props}
          />
        );
      })}
    </tbody>
  );
};

Body.propTypes = {
  ...TablePropTypes,
};

Body.defaultProps = {
  data: [],
};

export default Body;
